import { createAnalyticsEvent } from "@kells/apis/analytics";

enum EventTypes {
  AppLoadEvent = "App loaded",
}

export const appLoaded = createAnalyticsEvent(
  EventTypes.AppLoadEvent
);
